export class LatLng {
  constructor(
    public lat: number = null,
    public lng: number = null,
  ) { }
}
